export var BarChartDisplayMode;
(function (BarChartDisplayMode) {
    BarChartDisplayMode[BarChartDisplayMode["Absolute"] = 0] = "Absolute";
    BarChartDisplayMode[BarChartDisplayMode["Relative"] = 1] = "Relative";
    BarChartDisplayMode[BarChartDisplayMode["PerValue"] = 2] = "PerValue";
})(BarChartDisplayMode || (BarChartDisplayMode = {}));
export const maxDisplayModeIdx = Object.keys(BarChartDisplayMode).length;
/**
 * @param en The enum (type)
 * @param current The current enum value
 */
export function cycleEnumValues(en, current) {
    return current + 1 >= Object.keys(en).length / 2 ? 0 : current + 1;
}
